// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scroll[data-v-d98a9ce2] {\n    overflow-y: scroll\n}\n.testmove[data-v-d98a9ce2] {\n    display:block;\n    position: absolute;\n    height: 100px;\n    width: 200px;\n    cursor: pointer;\n}\n.modaltitle[data-v-d98a9ce2] {\n    background: blue;\n    display:block;\n    width:100%;\n    color: white;\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
